import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import IconBox from '../IconBox'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function ServiceDetailsPage() {
  pageTitle('3D Asset Creation');
  const params = useParams();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <PageHeading
        title='3D Asset Creation'
        bgSrc='/images/service_hero_bg.jpeg'
        pageLinkText={'3D Asset Creation'}
      />

      <Spacing lg='145' md='80' />

      {/* Introduction Section */}
      <Div className="container">
        <SectionHeading
          title='High-Quality 3D Asset Creation'
          subtitle='Bring Your Vision to Life with Stunning 3D Models'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <p className='cs-text_large text-center'>
          At Dappster Studio, we specialize in crafting visually stunning, production-ready 3D assets for games, virtual reality, augmented reality, animations, and more. Whether stylized or photorealistic, our assets are optimized for performance and realism.
        </p>
        <Spacing lg='20' md='15' />
        <p className='cs-text_large text-center'>
          Using industry-standard tools like Blender, Maya, ZBrush, and Substance Painter, our artists deliver 3D models with clean topology, proper UV mapping, PBR texturing, and animation-ready rigs tailored to your platform and use case.
        </p>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Services Section */}
      <Div className="container">
        <SectionHeading
          title='Our 3D Asset Services'
          subtitle='Custom 3D Models for Any Digital Experience'
          variant='cs-style1 text-center'
        />
        <Spacing lg='90' md='45' />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_1.svg'
              title='Character Modeling'
              subtitle='Detailed humanoid and creature models, stylized or realistic, fully rigged and animation-ready.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_2.svg'
              title='Environment Design'
              subtitle='Immersive 3D environments, landscapes, and world-building for games and simulations.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_3.svg'
              title='Product Visualization'
              subtitle='Photorealistic 3D assets for product demos, ads, AR/VR previews, and prototyping.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_4.svg'
              title='Game-Ready Assets'
              subtitle='Optimized 3D models for Unity, Unreal Engine, or WebGL, with LODs and efficient textures.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_5.svg'
              title='3D Animation & Rigging'
              subtitle='Bone rigging, facial rigs, and custom animations for interactive characters and objects.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_6.svg'
              title='Texture & Material Creation'
              subtitle='High-quality PBR textures using Substance tools, tailored for realistic lighting and shading.'
            />
            <Spacing lg='30' md='30' />
          </Div>
        </Div>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Industries Section */}
      <Div className="container">
        <SectionHeading
          title='Industries We Serve'
          subtitle='3D Assets Tailored for Every Industry'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/game-icon.svg'
              title='Gaming'
              subtitle='From indie games to AAA titles, we provide characters, props, and environments that elevate gameplay.'
            />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/vr-icon.svg'
              title='Virtual & Augmented Reality'
              subtitle='Low-poly and optimized assets for immersive VR/AR experiences across devices.'
            />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/cart-icon.svg'
              title='E-commerce & Marketing'
              subtitle='Interactive 3D models of products for online stores, configurators, and ads.'
            />
          </Div>
        </Div>

        <Div className="row mt-lg-5" >
          <Div className="col-lg-6">
            <IconBox
              icon='/images/icons/house-icon.svg'
              title='Architecture & Real Estate'
              subtitle='3D visualizations, walkthroughs, and interior renders for property promotion and planning.'
            />
          </Div>
          <Div className="col-lg-6">
            <IconBox
              icon='/images/icons/media-icon.svg'
              title='Film & Animation'
              subtitle='Cinematic-quality models and assets for animated shorts, VFX, and storytelling.'
            />
          </Div>
        </Div>
      </Div>

      <Spacing lg='150' md='80' />
    </>
  )
}
